import { render, staticRenderFns } from "./BalanceTopupSuccessView.vue?vue&type=template&id=1fd7d1fa"
import script from "./BalanceTopupSuccessView.vue?vue&type=script&lang=js"
export * from "./BalanceTopupSuccessView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports